
export const config = {
    icon: "Table"
}